const ENDPOINT_PREFIX = '/provider-service/resources';

function mountEndpoint(endpoint: string, prefix: string = ENDPOINT_PREFIX): string {
  return `${prefix}${endpoint}`;
}

export const BaseEndpoint = {
  INFORMATION: mountEndpoint('/information'),
  REFRESH: mountEndpoint('/authentication'),
  REVOKE: mountEndpoint('/logout'),
  THEME: mountEndpoint('/configuration'),
};
